<!-- @Version: 1.0.2 --> 
@if (done$$() == true) {
  <div data-testid="combofieldcontainer" [formGroup]="fgCombofield" class="row">
    <mat-form-field  data-width="100%" [hideRequiredMarker]="hideRequireMaker" >
      @if (fieldItem.attribute_1 && fieldItem.attribute_1 != '') {
        <mat-label data-testid="label" [innerHTML]="fieldItem.attribute_1"></mat-label>
      }
      <mat-select  data-testid="combofield" [formControlName]="FC_COMBOFIELD.COMBOFIELD" [required]="fieldItem.required! && !fgCombofield.get(FC_COMBOFIELD.COMBOFIELD)?.disabled"  [placeholder]="fieldItem.placeholder ?? ''">
        <mat-option data-testid="emtyOption">--</mat-option>
        @for (item of selection; track item) {
          <mat-option data-testid="options" [value]="item">
            {{item}}
          </mat-option>
        }
      </mat-select>
      @if (fgCombofield.get(FC_COMBOFIELD.COMBOFIELD)?.hasError(VALIDATORS.required) && fgCombofield.get(FC_COMBOFIELD.COMBOFIELD)?.touched ) {
        <mat-error data-testid="errorRequired" [innerHTML]="error.errorCodeRequired"></mat-error>
      }
    </mat-form-field>
  </div>
}